module.exports = __webpack_public_path__ + "img/marcus-hero-alt copy.60adc939.png";